"use strict";

require("../../styles/theme.scss");

require("../../styles/theme.scss.liquid");

require("../global/helpers/polyfill");

require("../components/cart/Cart");

require("../global/navigation");